var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"v-html-text"}},[_c('div',{staticClass:"bc-simple-content bc-simple-content-sb",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }